import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { CashOutModal } from '../model/index';

@Injectable()
export class CashOutService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers({
    //    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

    //     //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    // });
    private cashOut = 'api/cashOut';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getCashOutList(query: any): Promise<CashOutModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashOut}/getCashOutListDet`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addCashOut(query: any): Promise<CashOutModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashOut}/addCashOut`;
        return this.http
        // .get(url, options)
        .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteCashOut(rowData: any): Promise<CashOutModal> {
        const url = `${this.cashOut}/deleteCashOutList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashOutModal)
            .catch(this.handleError);
    }

    UpdateCashOut(testbilldetail: any): Promise<CashOutModal> {

        const url = `${this.cashOut}/updateCashOutData`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashOutModal)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/cashOut.service.ts